export default {
  namespaced: true,
  state: {
    contentItems: []
  },
  getters: {
    contentItems: state => state.contentItems
  },
  actions: {
    resetCurrentDeclaration: (context) => {
      context.commit('resetCurrentDeclaration');
    },
    setContentItems: (context, contentItems) => {
      //Deep copy the contentItems, so that the user can keep adding contentItems on the UI without interfering with the vuex state.     
      const deepCopyContentItems = contentItems.map(contentItem => ({ ...contentItem })); //This only works if the array contains objects which only contain primitive properties!
      context.commit("setContentItems", deepCopyContentItems);
    },
  },
  mutations: {
    resetCurrentDeclaration: (state) => {
      state.contentItems = [];
    },
    addItem(state, newItem) {
      state.contentItems.push(newItem);
    },
    setContentItems: (state, contentItems) => {
      state.contentItems = contentItems;
    }
  }
}
